import {
    useRouter
} from 'next/router';
import {
    useEffect
} from 'react';
import Loading from '../../../components/core/loading';
import {
    naltrexoneOnlyDiagnosticFormId
} from '../../../logic/auth';

export default function RedirectToMedFirstDiagnostic(): JSX.Element {
    const router = useRouter();
    useEffect(() => {
        if (!router.isReady) {
            return;
        }
        router.replace(`/mf/diagnostic/${naltrexoneOnlyDiagnosticFormId}/0`);
    }, [router?.isReady]);

    return <Loading />;
}
